import React from "react";

interface Props {
  src: string;
}

export const Logo: React.FC<Props> = props => (
  <img id="appName" src={props.src} style={{ width: "100%" }} alt="Logo" />
);
